var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"forgotten-password-page"}},[_c('AppHero',{attrs:{"heading":_vm.heroHeading}},[(!_vm.formSubmitted)?_c('ForgottenPassword',{on:{"hideForm":_vm.showConfirmation}}):_vm._e(),(_vm.formSubmitted)?_c('PasswordEmailConfirmation'):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }